import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id BFF59001-B52D-47E6-A217-C9095F81C3B8
 * name file
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file.svg
 * tags
 * - Files / Folders 
 */
export const FileIcon = createSvgIcon(<><path d="M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" /></>, 'FileIcon');
export default FileIcon